// extracted by mini-css-extract-plugin
module.exports = {"ReserveForm__actions":"ReserveForm_ReserveForm__actions__10gE4","ReserveForm__textField":"ReserveForm_ReserveForm__textField__F_enb"};